import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core'
import { DatePipe } from '@angular/common'
import { QuoteTrackingService } from '../quote-tracking.service'
import { Router } from '@angular/router'
import { Observable, of } from 'rxjs'
import { saveAs } from 'file-saver'
import {
  GlobalMessageService,
  GlobalMessageType,
  TranslationService,
} from '@spartacus/core'
import { StatusTile } from '../../../../shared/components/status-tiles/status-tiles.component'
import {
  CurrentQuoteStatus,
  StatusType,
} from '../../../../models/status/status.model'
import {
  ACCESSIBILITY,
  UserRoleService,
} from '../../../../shared/services/user-role.service'
import { BreadcrumbService } from '../../../../shared/components/breadcrumb/breadcrumb.service'
import { CommonService } from '../../../../shared/services/common.service'
import { QuoteStatusTypes } from '../../../../models/status/quote-status.model'
import { DateRange } from '../../../../shared/components/date-range-picker/date-range-picker.component'
const QUOTETYPE_OPTIONS = [
  {
    label: 'All',
    value: 'All',
  },
  {
    label: 'Standard',
    value: 'STD',
  },
  {
    label: 'Fast track',
    value: 'FQT',
  },
]
@Component({
  standalone: false,
  selector: 'app-quote-list',
  templateUrl: './quote-list.component.html',
  styleUrls: ['./quote-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class QuoteListComponent implements OnInit, OnDestroy {
  // public displayedColumns;
  public dataSource
  quoteTiles: StatusTile[]
  public defaultTile
  firstStatusType: StatusType
  fromDate
  toDate
  public searchFilter: boolean
  public fromDateDisply
  public toDateDisply
  public dateRange: boolean
  public tableData
  public tableData$: Observable<any>
  public updatedTableData$: Observable<any>
  public status
  public searchId
  public createdby
  public searchtext: string = 'Search'
  public showSearch: boolean
  public noData: boolean
  loading = true
  public toMinDate
  public fromMaxDate
  public fromMax
  public displayStatus
  public changeDate: boolean = false
  full: boolean = true
  public statusFilter: boolean
  public searchcreatedby: boolean
  public currency
  public strTrim
  public jpyCurrency
  clearAll: boolean = false
  PageSize: number = 50
  crntPage = 0
  totalPages: any
  totalResult
  totalQuotes
  isLoadMoreInProgress = false
  public UG_VIEW_ONLY
  public apiError: boolean
  quotes = []
  CurrentQuoteStatus = CurrentQuoteStatus
  accessibility = ACCESSIBILITY
  monthDifference: number = 6
  getMonths$: Observable<any>
  selectedCreated
  dateObject: any
  findByQuoteTypeList = QUOTETYPE_OPTIONS
  findByQuoteType = this.findByQuoteTypeList[0].value
  quoteType: any
  quoteTypeFlag: boolean
  constructor(
    private breadCrumbService: BreadcrumbService,
    public datepipe: DatePipe,
    private globalMessageService: GlobalMessageService,
    public quoteTrackingService: QuoteTrackingService,
    public router: Router,
    private commonService: CommonService,
    private cRef: ChangeDetectorRef,
    private userRoleService: UserRoleService,
    private translate: TranslationService
  ) {
    this.dateRange = false
    this.status = null
    this.fromDate = ''
    this.toDate = ''
    this.searchId = null
    this.searchFilter = false
    this.statusFilter = false
    this.showSearch = true
    this.firstStatusType = StatusType.QUOTE
    this.quoteTiles = [
      {
        quoteStatus: QuoteStatusTypes.TOTAL,
        statusType: StatusType.QUOTE,
      },
      {
        quoteStatus: QuoteStatusTypes.SUBMITTED,
        statusType: StatusType.QUOTE,
        colorTheme: 'submitted',
        //statusCount: this.tableData.Created,
      },
      {
        quoteStatus: QuoteStatusTypes.PROGRESS,
        statusType: StatusType.QUOTE,
        colorTheme: 'progress',
        tooltip: 'test',
      },
      {
        quoteStatus: QuoteStatusTypes.PENDING,
        statusType: StatusType.QUOTE,
        colorTheme: 'pending',
        tooltip:
          'We have assigned a ship date to all of your line items. Some line items may have moved further, but at least one item is not yet shipped.',
      },
      {
        quoteStatus: QuoteStatusTypes.RETURNED,
        statusType: StatusType.QUOTE,
        colorTheme: 'returned',
        tooltip: 'test',
      },
      {
        quoteStatus: QuoteStatusTypes.CLOSED,
        statusType: StatusType.QUOTE,
        colorTheme: 'closed',
        tooltip: 'test',
      },
      {
        quoteStatus: QuoteStatusTypes.EXPIRED,
        statusType: StatusType.QUOTE,
        colorTheme: 'expired',
        tooltip: 'test',
      },
    ]
    this.getMonths$ = this.quoteTrackingService.getConfigMonth()
    this.getMonths$.subscribe((success: any) => {
      this.monthDifference = parseInt(success)
      this.fromMax = new Date()
      this.fromMaxDate = new Date()
      this.fromMaxDate = this.fromMax.setMonth(
        this.fromMax.getMonth() - this.monthDifference
      )
      this.toMinDate = new Date()
      this.toDate = this.datepipe.transform(this.toMinDate, 'yyyy-MM-dd')
      this.fromDate = this.datepipe.transform(this.fromMax, 'yyyy-MM-dd')
      this.dateObject = {
        fromDate: this.fromDate,
        toDate: this.toDate,
      }
      this.cRef.detectChanges()
      this.refreshList(false)
    })
  }
  changeQuoteType(val) {
    this.quoteType = val
    if (val == 'STD' || val == 'FQT') {
      this.quoteTypeFlag = true
      this.clearAll = true
    } else {
      this.quoteTypeFlag = false
      this.quoteType = null
      if (!this.searchcreatedby && !this.dateRange && !this.searchFilter)
        this.clearAll = false
    }

    // this.showSearch=false;
    // this.searchFilter=false;
    // this.searchcreatedby=true;

    // this.searchtext= search;
    // this.searchId=val;

    this.noData = false
    this.crntPage = 0
    const obj = {
      createdDate: null,
      searchText: this.searchId,
      quoteReference: null,
      quoteStatusLabel: this.status,
      quoteTotal: null,
      endDate: this.toDate,
      startDate: this.fromDate,
      quoteRefreshFlag: false,
      PageSize: this.PageSize,
      currentPage: this.crntPage,
      quoteType: this.quoteType,
    }
    this.updatedTableData$ = this.quoteTrackingService.getQuote(obj)
    this.updatedTableData$.subscribe((res) => {
      this.noData = false
      this.tableData = res

      if (this.tableData.pagination !== undefined) {
        this.crntPage = this.tableData.pagination.currentPage
        this.totalPages = this.tableData.pagination.totalPages
        this.totalQuotes = this.tableData.pagination.totalResults
      } else {
        this.crntPage = 0
        this.totalPages = 0
        this.totalQuotes = 0
      }
      this.quoteTiles = [
        {
          quoteStatus: QuoteStatusTypes.TOTAL,
          statusType: StatusType.QUOTE,
          statusCount: this.tableData.allQuotes,
        },
        {
          quoteStatus: QuoteStatusTypes.SUBMITTED,
          statusType: StatusType.QUOTE,
          colorTheme: 'submitted',
          statusCount: this.tableData.created,
        },
        {
          quoteStatus: QuoteStatusTypes.PROGRESS,
          statusType: StatusType.QUOTE,
          colorTheme: 'progress',
          statusCount: this.tableData.inProgress,
        },
        {
          quoteStatus: QuoteStatusTypes.PENDING,
          statusType: StatusType.QUOTE,
          colorTheme: 'pending',
          statusCount: this.tableData.pendingAcceptance,
        },
        {
          quoteStatus: QuoteStatusTypes.RETURNED,
          statusType: StatusType.QUOTE,
          colorTheme: 'returned',
          statusCount: this.tableData.revisionRequested,
        },
        {
          quoteStatus: QuoteStatusTypes.CLOSED,
          statusType: StatusType.QUOTE,
          colorTheme: 'closed',
          statusCount: this.tableData.closed,
        },
        {
          quoteStatus: QuoteStatusTypes.EXPIRED,
          statusType: StatusType.QUOTE,
          colorTheme: 'expired',
          statusCount: this.tableData.expired,
        },
      ]
      if (this.tableData.quoteListingList.length > 0) {
        this.dataSource = [...this.tableData.quoteListingList]
        this.decreasing()
      } else {
        this.noData = true
      }
    })
  }
  ngOnInit(): void {
    this.quoteTrackingService.getQuotesForMerge.subscribe((quotes) => {
      this.quotes = quotes
    })
    this.currency = sessionStorage.getItem('currency')
    this.quoteTrackingService.emitTileStatus('All Quotes')
    this.loading = true
    this.breadCrumbService.setBreadCrumbs([])
    this.translate
      .translate('quoteTracking.myQuotes')
      .subscribe((res: string) =>
        this.breadCrumbService.setBreadcrumbTitle(res)
      )

    this.quoteTrackingService.getRolesOfcust().subscribe((res) => {
      this.UG_VIEW_ONLY = res
    })
    // this.loadmoredatadropdown();
  }

  displayedColumns = [
    'Quote',
    'QuoteCreatedDate',
    'QuoteStatus',
    'QuoteRef',
    'QuoteTotal',
    'merge',
  ]

  selectedQuote(element) {
    this.router.navigate(['/quote-detail', element], {
      queryParams: this.dateObject,
    })
  }

  onTileClick(e: StatusTile) {
    this.clearAll = true
    this.crntPage = 0
    this.statusFilter = true
    this.quoteTrackingService.emitTileStatus(e.quoteStatus.status)
    switch (e.quoteStatus.status) {
      case 'All Quotes':
        this.status = null
        this.searchId = null
        this.statusFilter = false
        this.searchFilter = false
        this.dateRange = false
        if (this.dateRange || this.status != null) {
          this.clearAll = true
        } else {
          this.clearAll = false
        }
        this.toDate = this.datepipe.transform(this.toMinDate, 'yyyy-MM-dd')
        this.fromDate = this.datepipe.transform(this.fromMax, 'yyyy-MM-dd')
        break

      case 'In Progress':
        this.status = e.quoteStatus.status
        this.displayStatus = e.quoteStatus.status
        break

      case 'Pending Action':
        this.status = 'Pending - Customer Acceptance'
        this.displayStatus = e.quoteStatus.status
        break

      case 'Revision Requested':
        this.status = e.quoteStatus.status
        this.displayStatus = e.quoteStatus.status
        break

      case 'Closed':
        this.status = e.quoteStatus.status
        this.displayStatus = e.quoteStatus.status
        break

      case 'Submitted':
        this.status = 'Submitted'
        this.displayStatus = e.quoteStatus.status
        break

      case 'Expired':
        this.status = e.quoteStatus.status
        this.displayStatus = e.quoteStatus.status
        break
    }
    const obj = {
      createdDate: null,
      searchText: this.selectedCreated,
      quoteReference: '',
      quoteStatusLabel: this.status,
      quoteTotal: '',
      endDate: this.toDate,
      startDate: this.fromDate,
      quoteRefreshFlag: false,
      PageSize: this.PageSize,
      currentPage: this.crntPage,
    }
    this.updatedTableData$ = this.quoteTrackingService.getQuote(obj)
    this.updatedTableData$.subscribe((res) => {
      this.noData = false
      this.tableData = res
      this.selectedCreated = (typeof(this.tableData.createdByList) == 'object') ? this.tableData.createdByList[0] : this.tableData.createdByList      
      if (this.tableData.pagination !== undefined) {
        this.crntPage = this.tableData.pagination.currentPage
        this.totalPages = this.tableData.pagination.totalPages
        this.totalQuotes = this.tableData.pagination.totalResults
      } else {
        this.crntPage = 0
        this.totalPages = 0
        this.totalQuotes = 0
      }
      this.quoteTiles = [
        {
          quoteStatus: QuoteStatusTypes.TOTAL,
          statusType: StatusType.QUOTE,
          statusCount: this.tableData.allQuotes,
        },
        {
          quoteStatus: QuoteStatusTypes.SUBMITTED,
          statusType: StatusType.QUOTE,
          colorTheme: 'submitted',
          statusCount: this.tableData.created,
        },
        {
          quoteStatus: QuoteStatusTypes.PROGRESS,
          statusType: StatusType.QUOTE,
          colorTheme: 'progress',
          statusCount: this.tableData.inProgress,
          tooltip: 'test',
        },
        {
          quoteStatus: QuoteStatusTypes.PENDING,
          statusType: StatusType.QUOTE,
          colorTheme: 'pending',
          statusCount: this.tableData.pendingAcceptance,
          tooltip: 'test',
        },
        {
          quoteStatus: QuoteStatusTypes.RETURNED,
          statusType: StatusType.QUOTE,
          colorTheme: 'returned',
          statusCount: this.tableData.revisionRequested,
          tooltip: 'test',
        },
        {
          quoteStatus: QuoteStatusTypes.CLOSED,
          statusType: StatusType.QUOTE,
          colorTheme: 'closed',
          statusCount: this.tableData.closed,
          tooltip: 'test',
        },
        {
          quoteStatus: QuoteStatusTypes.EXPIRED,
          statusType: StatusType.QUOTE,
          colorTheme: 'expired',
          statusCount: this.tableData.expired,
          tooltip: 'test',
        },
      ]
      if (this.tableData.quoteListingList.length > 0) {
        this.dataSource = [...this.tableData.quoteListingList]
        this.decreasing()
      } else {
        this.noData = true
      }
    })
  }

  getDateRange(e: DateRange) {
    this.crntPage = 0
    this.totalPages = 1
    this.fromDateDisply = e.from
    this.toDateDisply = e.to
    if (this.toDateDisply.date < this.fromDateDisply.date) {
      this.dateRange = false
    } else {
      this.clearAll = true
      this.fromDate = this.datepipe.transform(e.from.date, 'yyyy-MM-dd')
      this.toDate = this.datepipe.transform(e.to.date, 'yyyy-MM-dd')
      this.dateObject.fromDate = this.fromDate
      this.dateObject.toDate = this.toDate
      this.dateRange = true
      this.noData = false
      const obj = {
        createdDate: null,
        searchText: this.searchId,
        quoteReference: null,
        quoteStatusLabel: this.status,
        quoteTotal: null,
        endDate: this.toDate,
        startDate: this.fromDate,
        quoteRefreshFlag: false,
        PageSize: this.PageSize,
        currentPage: this.crntPage,
      }
      this.updatedTableData$ = this.quoteTrackingService.getQuote(obj)
      this.updatedTableData$.subscribe((res) => {
        this.noData = false
        this.tableData = res
        if (this.tableData.pagination !== undefined) {
          this.crntPage = this.tableData.pagination.currentPage
          this.totalPages = this.tableData.pagination.totalPages
          this.totalQuotes = this.tableData.pagination.totalResults
        } else {
          this.crntPage = 0
          this.totalPages = 0
          this.totalQuotes = 0
        }
        this.quoteTiles = [
          {
            quoteStatus: QuoteStatusTypes.TOTAL,
            statusType: StatusType.QUOTE,
            statusCount: this.tableData.allQuotes,
          },
          {
            quoteStatus: QuoteStatusTypes.SUBMITTED,
            statusType: StatusType.QUOTE,
            colorTheme: 'submitted',
            statusCount: this.tableData.created,
          },
          {
            quoteStatus: QuoteStatusTypes.PROGRESS,
            statusType: StatusType.QUOTE,
            colorTheme: 'progress',
            statusCount: this.tableData.inProgress,
            tooltip: 'test',
          },
          {
            quoteStatus: QuoteStatusTypes.PENDING,
            statusType: StatusType.QUOTE,
            colorTheme: 'pending',
            statusCount: this.tableData.pendingAcceptance,
            tooltip: 'test',
          },
          {
            quoteStatus: QuoteStatusTypes.RETURNED,
            statusType: StatusType.QUOTE,
            colorTheme: 'returned',
            statusCount: this.tableData.returned,
            tooltip: 'test',
          },
          {
            quoteStatus: QuoteStatusTypes.CLOSED,
            statusType: StatusType.QUOTE,
            colorTheme: 'closed',
            statusCount: this.tableData.closed,
            tooltip: 'test',
          },
          {
            quoteStatus: QuoteStatusTypes.EXPIRED,
            statusType: StatusType.QUOTE,
            colorTheme: 'expired',
            statusCount: this.tableData.expired,
            tooltip: 'test',
          },
        ]
        if (this.tableData.quoteListingList.length > 0) {
          this.dataSource = []
          this.dataSource = [...this.tableData.quoteListingList]
          this.decreasing()
        } else {
          this.noData = true
        }
      })
    }
  }
  // Search Quote
  modelChange(search) {
    this.searchcreatedby = false
    this.selectedCreated = null
    this.showSearch = false
    this.searchFilter = true
    this.clearAll = true
    this.searchtext = search
    this.searchId = search.trim()
    this.noData = false
    this.crntPage = 0
    const obj = {
      createdDate: null,
      searchText: this.searchId,
      quoteReference: null,
      quoteStatusLabel: this.status,
      quoteTotal: null,
      endDate: this.toDate,
      startDate: this.fromDate,
      quoteRefreshFlag: false,
      PageSize: this.PageSize,
      currentPage: this.crntPage,
    }
    this.updatedTableData$ = this.quoteTrackingService.getQuote(obj)
    this.updatedTableData$.subscribe((res) => {
      this.noData = false
      this.tableData = res

      if (this.tableData.pagination !== undefined) {
        this.crntPage = this.tableData.pagination.currentPage
        this.totalPages = this.tableData.pagination.totalPages
        this.totalQuotes = this.tableData.pagination.totalResults
      } else {
        this.crntPage = 0
        this.totalPages = 0
        this.totalQuotes = 0
      }
      this.quoteTiles = [
        {
          quoteStatus: QuoteStatusTypes.TOTAL,
          statusType: StatusType.QUOTE,
          statusCount: this.tableData.allQuotes,
        },
        {
          quoteStatus: QuoteStatusTypes.SUBMITTED,
          statusType: StatusType.QUOTE,
          colorTheme: 'submitted',
          statusCount: this.tableData.created,
        },
        {
          quoteStatus: QuoteStatusTypes.PROGRESS,
          statusType: StatusType.QUOTE,
          colorTheme: 'progress',
          statusCount: this.tableData.inProgress,
        },
        {
          quoteStatus: QuoteStatusTypes.PENDING,
          statusType: StatusType.QUOTE,
          colorTheme: 'pending',
          statusCount: this.tableData.pendingAcceptance,
        },
        {
          quoteStatus: QuoteStatusTypes.RETURNED,
          statusType: StatusType.QUOTE,
          colorTheme: 'returned',
          statusCount: this.tableData.revisionRequested,
        },
        {
          quoteStatus: QuoteStatusTypes.CLOSED,
          statusType: StatusType.QUOTE,
          colorTheme: 'closed',
          statusCount: this.tableData.closed,
        },
        {
          quoteStatus: QuoteStatusTypes.EXPIRED,
          statusType: StatusType.QUOTE,
          colorTheme: 'expired',
          statusCount: this.tableData.expired,
        },
      ]
      if (this.tableData.quoteListingList.length > 0) {
        this.dataSource = [...this.tableData.quoteListingList]
        this.decreasing()
      } else {
        this.noData = true
      }
    })
  }

  decreasing() {
    this.dataSource = [
      ...this.dataSource.sort(
        (a, b) => 0 - (a.createdDate > b.createdDate ? 1 : -1)
      ),
    ]
    // this.dataSource= [...this.dataSource.sort((a,b) =>
    // 0 - (a.quoteCreatedBy.toLowerCase() > b.quoteCreatedBy.toLowerCase() ? 1 : -1))];
  }
  increasing() {
    this.dataSource = [
      ...this.dataSource.sort(
        (a, b) => 0 - (a.createdDate < b.createdDate ? 1 : -1)
      ),
    ]
    // this.dataSource= [...this.dataSource.sort((a,b) =>
    //   0 - (a.quoteCreatedBy.toLowerCase() < b.quoteCreatedBy.toLowerCase() ? 1 : -1))];
  }
  clearQuoteTypeFilter() {
    this.quoteTypeFlag = false
    this.quoteType = null
    if (
      this.quoteTypeFlag ||
      this.dateRange ||
      this.searchFilter ||
      this.searchcreatedby ||
      this.status != null
    ) {
      this.clearAll = true
    } else {
      this.clearAll = false
    }
    // this.searchId=null;
    // this.searchFilter=false;
    // this.showSearch=true;
    this.crntPage = 0
    this.findByQuoteType = this.findByQuoteTypeList[0].value
    const obj = {
      createdDate: null,
      searchText: this.searchId,
      quoteReference: '',
      quoteStatusLabel: this.status,
      quoteTotal: '',
      endDate: this.toDate,
      startDate: this.fromDate,
      quoteRefreshFlag: false,
      PageSize: this.PageSize,
      currentPage: this.crntPage,
      quoteType: this.quoteType,
    }
    this.updatedTableData$ = this.quoteTrackingService.getQuote(obj)
    this.updatedTableData$.subscribe((res) => {
      this.noData = false
      this.tableData = res
      if (this.tableData.pagination !== undefined) {
        this.crntPage = this.tableData.pagination.currentPage
        this.totalPages = this.tableData.pagination.totalPages
        this.totalQuotes = this.tableData.pagination.totalResults
      } else {
        this.crntPage = 0
        this.totalPages = 0
        this.totalQuotes = 0
      }
      this.quoteTiles = [
        {
          quoteStatus: QuoteStatusTypes.TOTAL,
          statusType: StatusType.QUOTE,
          statusCount: this.tableData.allQuotes,
        },
        {
          quoteStatus: QuoteStatusTypes.SUBMITTED,
          statusType: StatusType.QUOTE,
          colorTheme: 'submitted',
          statusCount: this.tableData.created,
        },
        {
          quoteStatus: QuoteStatusTypes.PROGRESS,
          statusType: StatusType.QUOTE,
          colorTheme: 'progress',
          statusCount: this.tableData.inProgress,
        },
        {
          quoteStatus: QuoteStatusTypes.PENDING,
          statusType: StatusType.QUOTE,
          colorTheme: 'pending',
          statusCount: this.tableData.pendingAcceptance,
        },
        {
          quoteStatus: QuoteStatusTypes.RETURNED,
          statusType: StatusType.QUOTE,
          colorTheme: 'returned',
          statusCount: this.tableData.revisionRequested,
        },
        {
          quoteStatus: QuoteStatusTypes.CLOSED,
          statusType: StatusType.QUOTE,
          colorTheme: 'closed',
          statusCount: this.tableData.closed,
        },
        {
          quoteStatus: QuoteStatusTypes.EXPIRED,
          statusType: StatusType.QUOTE,
          colorTheme: 'expired',
          statusCount: this.tableData.expired,
        },
      ]
      if (this.tableData.quoteListingList.length > 0) {
        this.dataSource = [...this.tableData.quoteListingList]
        this.decreasing()
      } else {
        this.noData = true
      }
    })
  }
  clearcreatedbyFilter() {
    if (this.selectedCreated || this.status != null) {
      this.clearAll = true
    } else {
      this.clearAll = false
    }
    this.searchId = null
    this.searchFilter = false
    this.showSearch = true
    this.searchcreatedby = false
    this.selectedCreated = null
    this.crntPage = 0
    const obj = {
      createdDate: null,
      searchText: null,
      quoteReference: '',
      quoteStatusLabel: this.status,
      quoteTotal: '',
      endDate: this.toDate,
      startDate: this.fromDate,
      quoteRefreshFlag: false,
      PageSize: this.PageSize,
      currentPage: this.crntPage,
    }
    this.updatedTableData$ = this.quoteTrackingService.getQuote(obj)
    this.updatedTableData$.subscribe((res) => {
      this.noData = false
      this.tableData = res
      if (this.tableData.pagination !== undefined) {
        this.crntPage = this.tableData.pagination.currentPage
        this.totalPages = this.tableData.pagination.totalPages
        this.totalQuotes = this.tableData.pagination.totalResults
      } else {
        this.crntPage = 0
        this.totalPages = 0
        this.totalQuotes = 0
      }
      this.quoteTiles = [
        {
          quoteStatus: QuoteStatusTypes.TOTAL,
          statusType: StatusType.QUOTE,
          statusCount: this.tableData.allQuotes,
        },
        {
          quoteStatus: QuoteStatusTypes.SUBMITTED,
          statusType: StatusType.QUOTE,
          colorTheme: 'submitted',
          statusCount: this.tableData.created,
        },
        {
          quoteStatus: QuoteStatusTypes.PROGRESS,
          statusType: StatusType.QUOTE,
          colorTheme: 'progress',
          statusCount: this.tableData.inProgress,
        },
        {
          quoteStatus: QuoteStatusTypes.PENDING,
          statusType: StatusType.QUOTE,
          colorTheme: 'pending',
          statusCount: this.tableData.pendingAcceptance,
        },
        {
          quoteStatus: QuoteStatusTypes.RETURNED,
          statusType: StatusType.QUOTE,
          colorTheme: 'returned',
          statusCount: this.tableData.revisionRequested,
        },
        {
          quoteStatus: QuoteStatusTypes.CLOSED,
          statusType: StatusType.QUOTE,
          colorTheme: 'closed',
          statusCount: this.tableData.closed,
        },
        {
          quoteStatus: QuoteStatusTypes.EXPIRED,
          statusType: StatusType.QUOTE,
          colorTheme: 'expired',
          statusCount: this.tableData.expired,
        },
      ]
      if (this.tableData.quoteListingList.length > 0) {
        this.dataSource = [...this.tableData.quoteListingList]
        this.decreasing()
      } else {
        this.noData = true
      }
    })
  }
  clearSearchFilter() {
    if (this.dateRange || this.status != null) {
      this.clearAll = true
    } else {
      this.clearAll = false
    }
    this.searchId = null
    this.searchFilter = false
    this.showSearch = true
    this.crntPage = 0
    const obj = {
      createdDate: null,
      searchText: null,
      quoteReference: '',
      quoteStatusLabel: this.status,
      quoteTotal: '',
      endDate: this.toDate,
      startDate: this.fromDate,
      quoteRefreshFlag: false,
      PageSize: this.PageSize,
      currentPage: this.crntPage,
    }
    this.updatedTableData$ = this.quoteTrackingService.getQuote(obj)
    this.updatedTableData$.subscribe((res) => {
      this.noData = false
      this.tableData = res
      if (this.tableData.pagination !== undefined) {
        this.crntPage = this.tableData.pagination.currentPage
        this.totalPages = this.tableData.pagination.totalPages
        this.totalQuotes = this.tableData.pagination.totalResults
      } else {
        this.crntPage = 0
        this.totalPages = 0
        this.totalQuotes = 0
      }
      this.quoteTiles = [
        {
          quoteStatus: QuoteStatusTypes.TOTAL,
          statusType: StatusType.QUOTE,
          statusCount: this.tableData.allQuotes,
        },
        {
          quoteStatus: QuoteStatusTypes.SUBMITTED,
          statusType: StatusType.QUOTE,
          colorTheme: 'submitted',
          statusCount: this.tableData.created,
        },
        {
          quoteStatus: QuoteStatusTypes.PROGRESS,
          statusType: StatusType.QUOTE,
          colorTheme: 'progress',
          statusCount: this.tableData.inProgress,
        },
        {
          quoteStatus: QuoteStatusTypes.PENDING,
          statusType: StatusType.QUOTE,
          colorTheme: 'pending',
          statusCount: this.tableData.pendingAcceptance,
        },
        {
          quoteStatus: QuoteStatusTypes.RETURNED,
          statusType: StatusType.QUOTE,
          colorTheme: 'returned',
          statusCount: this.tableData.revisionRequested,
        },
        {
          quoteStatus: QuoteStatusTypes.CLOSED,
          statusType: StatusType.QUOTE,
          colorTheme: 'closed',
          statusCount: this.tableData.closed,
        },
        {
          quoteStatus: QuoteStatusTypes.EXPIRED,
          statusType: StatusType.QUOTE,
          colorTheme: 'expired',
          statusCount: this.tableData.expired,
        },
      ]
      if (this.tableData.quoteListingList.length > 0) {
        this.dataSource = [...this.tableData.quoteListingList]
        this.decreasing()
      } else {
        this.noData = true
      }
    })
  }
  clearStatusFilter() {
    if (this.dateRange || this.searchId != null) {
      this.clearAll = true
    } else {
      this.clearAll = false
    }
    this.status = null
    this.statusFilter = false
    this.quoteTrackingService.emitTileStatus('All Quotes')
    this.showSearch = true
    this.crntPage = 0
    const obj = {
      createdDate: null,
      searchText: this.searchId,
      quoteReference: '',
      quoteStatusLabel: this.status,
      quoteTotal: '',
      endDate: this.toDate,
      startDate: this.fromDate,
      quoteRefreshFlag: false,
      PageSize: this.PageSize,
      currentPage: this.crntPage,
    }
    this.updatedTableData$ = this.quoteTrackingService.getQuote(obj)
    this.updatedTableData$.subscribe((res) => {
      this.noData = false
      this.tableData = res
      if (this.tableData.pagination !== undefined) {
        this.crntPage = this.tableData.pagination.currentPage
        this.totalPages = this.tableData.pagination.totalPages
        this.totalQuotes = this.tableData.pagination.totalResults
      } else {
        this.crntPage = 0
        this.totalPages = 0
        this.totalQuotes = 0
      }
      this.quoteTiles = [
        {
          quoteStatus: QuoteStatusTypes.TOTAL,
          statusType: StatusType.QUOTE,
          statusCount: this.tableData.allQuotes,
        },
        {
          quoteStatus: QuoteStatusTypes.SUBMITTED,
          statusType: StatusType.QUOTE,
          colorTheme: 'submitted',
          statusCount: this.tableData.created,
        },
        {
          quoteStatus: QuoteStatusTypes.PROGRESS,
          statusType: StatusType.QUOTE,
          colorTheme: 'progress',
          statusCount: this.tableData.inProgress,
        },
        {
          quoteStatus: QuoteStatusTypes.PENDING,
          statusType: StatusType.QUOTE,
          colorTheme: 'pending',
          statusCount: this.tableData.pendingAcceptance,
        },
        {
          quoteStatus: QuoteStatusTypes.RETURNED,
          statusType: StatusType.QUOTE,
          colorTheme: 'returned',
          statusCount: this.tableData.revisionRequested,
        },
        {
          quoteStatus: QuoteStatusTypes.CLOSED,
          statusType: StatusType.QUOTE,
          colorTheme: 'closed',
          statusCount: this.tableData.closed,
        },
        {
          quoteStatus: QuoteStatusTypes.EXPIRED,
          statusType: StatusType.QUOTE,
          colorTheme: 'expired',
          statusCount: this.tableData.expired,
        },
      ]
      if (this.tableData.quoteListingList.length > 0) {
        this.dataSource = [...this.tableData.quoteListingList]
        this.decreasing()
      } else {
        this.noData = true
      }
    })
  }
  clearDateFilter() {
    if (this.searchId != null || this.status != null) {
      this.clearAll = true
    } else {
      this.clearAll = false
    }
    this.changeDate = true
    this.noData = false
    this.dateRange = !this.dateRange
    this.fromMax = new Date()
    this.fromMaxDate = this.fromMax.setMonth(
      this.fromMax.getMonth() - this.monthDifference
    )
    this.toMinDate = new Date()
    this.toDate = this.datepipe.transform(this.toMinDate, 'yyyy-MM-dd')
    this.fromDate = this.datepipe.transform(this.fromMax, 'yyyy-MM-dd')
    this.crntPage = 0
    const obj = {
      createdDate: null,
      searchText: this.searchId,
      quoteReference: '',
      quoteStatusLabel: this.status,
      quoteTotal: '',
      endDate: this.toDate,
      startDate: this.fromDate,
      quoteRefreshFlag: false,
      PageSize: this.PageSize,
      currentPage: this.crntPage,
    }
    this.updatedTableData$ = this.quoteTrackingService.getQuote(obj)
    this.updatedTableData$.subscribe((res) => {
      this.noData = false
      this.tableData = res
      if (this.tableData.pagination !== undefined) {
        this.crntPage = this.tableData.pagination.currentPage
        this.totalPages = this.tableData.pagination.totalPages
        this.totalQuotes = this.tableData.pagination.totalResults
      } else {
        this.crntPage = 0
        this.totalPages = 0
        this.totalQuotes = 0
      }
      this.quoteTiles = [
        {
          quoteStatus: QuoteStatusTypes.TOTAL,
          statusType: StatusType.QUOTE,
          statusCount: this.tableData.allQuotes,
        },
        {
          quoteStatus: QuoteStatusTypes.SUBMITTED,
          statusType: StatusType.QUOTE,
          colorTheme: 'submitted',
          statusCount: this.tableData.created,
        },
        {
          quoteStatus: QuoteStatusTypes.PROGRESS,
          statusType: StatusType.QUOTE,
          colorTheme: 'progress',
          statusCount: this.tableData.inProgress,
        },
        {
          quoteStatus: QuoteStatusTypes.PENDING,
          statusType: StatusType.QUOTE,
          colorTheme: 'pending',
          statusCount: this.tableData.pendingAcceptance,
        },
        {
          quoteStatus: QuoteStatusTypes.RETURNED,
          statusType: StatusType.QUOTE,
          colorTheme: 'returned',
          statusCount: this.tableData.revisionRequested,
        },
        {
          quoteStatus: QuoteStatusTypes.CLOSED,
          statusType: StatusType.QUOTE,
          colorTheme: 'closed',
          statusCount: this.tableData.closed,
        },
        {
          quoteStatus: QuoteStatusTypes.EXPIRED,
          statusType: StatusType.QUOTE,
          colorTheme: 'expired',
          statusCount: this.tableData.expired,
        },
      ]
      if (this.tableData.quoteListingList.length > 0) {
        this.dataSource = [...this.tableData.quoteListingList]
        this.decreasing()
      } else {
        this.noData = true
      }
    })
  }
  getClearDate(clearDate) {
    this.changeDate = false
  }
  currentlyLoading: boolean = false
  loadMoreOrders() {
    if(this.selectedCreated){
      this.searchId = (typeof(this.selectedCreated) == 'object' ) ? null : this.selectedCreated
    }
    if (this.isLoadMoreInProgress) {
      return
    }
    if (this.currentlyLoading) {
      return
    }
    if (this.totalPages < 2) {
      return
    }
    this.currentlyLoading = true
    let currentPage = this.crntPage
    currentPage++
    if (currentPage <= this.totalPages - 1) {
      const obj = {
        createdDate: null,
        searchText: this.searchId,
        quoteReference: '',
        quoteStatusLabel: this.status,
        quoteTotal: '',
        endDate: this.toDate,
        startDate: this.fromDate,
        quoteRefreshFlag: false,
        PageSize: this.PageSize,
        currentPage: currentPage,
        quoteType: this.quoteType,
      }
      this.quoteTrackingService.getQuote(obj).subscribe(
        (res: any) => {
          if (res !== null && res !== undefined) {
            this.isLoadMoreInProgress = false
            if (res.pagination !== undefined) {
              this.crntPage = res.pagination.currentPage
              this.totalPages = res.pagination.totalPages
              this.totalQuotes = res.pagination.totalResults
            } else {
              this.crntPage = 0
              this.totalPages = 0
              this.totalQuotes = 0
            }
            if (res.quoteListingList && res.quoteListingList.length) {
              this.dataSource = this.dataSource.concat(res.quoteListingList)
            }
            this.currentlyLoading = false
          } else {
            this.isLoadMoreInProgress = false
            this.currentlyLoading = false
            this.globalMessageService.add(
              { key: 'quoteTracking.issueLoadingQuoteList' },
              GlobalMessageType.MSG_TYPE_ERROR,
              5000
            )
            window.scrollTo(0, 0)
          }
          this.noData = false
          this.decreasing()
        },
        (err) => {
          this.isLoadMoreInProgress = false
          this.currentlyLoading = false
          this.globalMessageService.add(
            { key: 'quoteTracking.issueLoadingQuoteList' },
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )
    } else {
      this.isLoadMoreInProgress = false
      this.currentlyLoading = false
    }
  }
  mergeQuotes(quote) {
    var existed = false
    if (this.quotes.length < 3) {
      this.quotes.forEach((element) => {
        if (element.quoteId == quote.quoteId) {
          existed = true

          this.globalMessageService.add(
            { key: 'quoteTracking.quoteExistMergeTray' },
            GlobalMessageType.MSG_TYPE_ERROR,
            10000
          )
          return
        }
        return
      })
      if (existed === false) {
        this.quotes.push(quote)
        this.globalMessageService.add(
          { key: 'quoteTracking.quoteAddedSuccessfully' },
          GlobalMessageType.MSG_TYPE_CONFIRMATION,
          10000
        )
      }
    } else {
      this.globalMessageService.add(
        { key: 'quoteTracking.quoteTrayFull' },
        GlobalMessageType.MSG_TYPE_ERROR,
        10000
      )
      return
    }
  }
  updateQuotes(event) {
    this.quotes = event
  }
  refreshList(status) {
    this.searchtext = 'Search'
    this.clearAll = false
    this.crntPage = 0
    const obj = {
      createdDate: null,
      searchText: this.searchId,
      quoteReference: null,
      quoteStatusLabel: this.status,
      quoteTotal: null,
      endDate: this.toDate,
      startDate: this.fromDate,
      quoteRefreshFlag: status,
      pageSize: this.PageSize,
      currentPage: this.crntPage,
    }
    this.updatedTableData$ = this.quoteTrackingService.getQuote(obj)
    // this.tableData$ = this.quoteTrackingService.getQuote(obj)
    this.updatedTableData$.subscribe(
      (res) => {
        this.tableData$ = this.updatedTableData$
        this.createdby = res
        this.tableData = res
        if (this.tableData.pagination !== undefined) {
          this.crntPage = this.tableData.pagination.currentPage
          this.totalPages = this.tableData.pagination.totalPages
          this.totalQuotes = this.tableData.pagination.totalResults
        } else {
          this.crntPage = 0
          this.totalPages = 0
          this.totalQuotes = 0
        }
        this.totalResult = this.tableData.pagination.totalResults
        this.noData = false
        this.apiError = false
        this.quoteTiles = [
          {
            quoteStatus: QuoteStatusTypes.TOTAL,
            statusType: StatusType.QUOTE,
            statusCount: this.tableData.allQuotes,
          },
          {
            quoteStatus: QuoteStatusTypes.SUBMITTED,
            statusType: StatusType.QUOTE,
            colorTheme: 'submitted',
            statusCount: this.tableData.created,
          },
          {
            quoteStatus: QuoteStatusTypes.PROGRESS,
            statusType: StatusType.QUOTE,
            colorTheme: 'progress',
            statusCount: this.tableData.inProgress,
          },
          {
            quoteStatus: QuoteStatusTypes.PENDING,
            statusType: StatusType.QUOTE,
            colorTheme: 'pending',
            statusCount: this.tableData.pendingAcceptance,
          },
          {
            quoteStatus: QuoteStatusTypes.RETURNED,
            statusType: StatusType.QUOTE,
            colorTheme: 'returned',
            statusCount: this.tableData.revisionRequested,
          },
          {
            quoteStatus: QuoteStatusTypes.CLOSED,
            statusType: StatusType.QUOTE,
            colorTheme: 'closed',
            statusCount: this.tableData.closed,
          },
          {
            quoteStatus: QuoteStatusTypes.EXPIRED,
            statusType: StatusType.QUOTE,
            colorTheme: 'expired',
            statusCount: this.tableData.expired,
          },
        ]
        if (this.tableData.quoteListingList.length > 0) {
          this.dataSource = this.tableData.quoteListingList
          this.decreasing()
          this.firstStatusType = StatusType.QUOTE
        } else {
          this.noData = true
        }
        //this.loading = false;
      },
      (error) => {
        if (error.status === 400) {
        }

        this.apiError = true
      }
    )
  }
  ngOnDestroy() {
    this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_ERROR)
    this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_CONFIRMATION)
  }
  clear() {
    this.clearAll = false
    this.showSearch = true
    this.searchcreatedby = false
    this.quoteTypeFlag = false
    this.selectedCreated = null
    this.statusFilter = false
    this.quoteTrackingService.emitTileStatus('All Quotes')
    this.searchtext = 'Search'
    this.fromMax = new Date()
    this.fromMaxDate = this.fromMax.setMonth(
      this.fromMax.getMonth() - this.monthDifference
    )
    this.toMinDate = new Date()
    this.toDate = this.datepipe.transform(this.toMinDate, 'yyyy-MM-dd')
    this.fromDate = this.datepipe.transform(this.fromMax, 'yyyy-MM-dd')
    this.findByQuoteType = this.findByQuoteTypeList[0].value
    this.dateRange = false
    this.searchFilter = false
    this.searchId = null
    this.crntPage = 0
    this.PageSize = 50
    this.status = null
    const obj = {
      createdDate: null,
      searchText: null,
      quoteReference: '',
      quoteStatusLabel: null,
      quoteTotal: '',
      endDate: this.toDate,
      startDate: this.fromDate,
      quoteRefreshFlag: false,
      PageSize: this.PageSize,
      currentPage: this.crntPage,
    }
    this.updatedTableData$ = this.quoteTrackingService.getQuote(obj)
    this.updatedTableData$.subscribe((res) => {
      this.noData = false
      this.tableData = res
      if (this.tableData.pagination !== undefined) {
        this.crntPage = this.tableData.pagination.currentPage
        this.totalPages = this.tableData.pagination.totalPages
        this.totalQuotes = this.tableData.pagination.totalResults
      } else {
        this.crntPage = 0
        this.totalPages = 0
        this.totalQuotes = 0
      }
      this.quoteTiles = [
        {
          quoteStatus: QuoteStatusTypes.TOTAL,
          statusType: StatusType.QUOTE,
          statusCount: this.tableData.allQuotes,
        },
        {
          quoteStatus: QuoteStatusTypes.SUBMITTED,
          statusType: StatusType.QUOTE,
          colorTheme: 'submitted',
          statusCount: this.tableData.created,
        },
        {
          quoteStatus: QuoteStatusTypes.PROGRESS,
          statusType: StatusType.QUOTE,
          colorTheme: 'progress',
          statusCount: this.tableData.inProgress,
        },
        {
          quoteStatus: QuoteStatusTypes.PENDING,
          statusType: StatusType.QUOTE,
          colorTheme: 'pending',
          statusCount: this.tableData.pendingAcceptance,
        },
        {
          quoteStatus: QuoteStatusTypes.RETURNED,
          statusType: StatusType.QUOTE,
          colorTheme: 'returned',
          statusCount: this.tableData.revisionRequested,
        },
        {
          quoteStatus: QuoteStatusTypes.CLOSED,
          statusType: StatusType.QUOTE,
          colorTheme: 'closed',
          statusCount: this.tableData.closed,
        },

        {
          quoteStatus: QuoteStatusTypes.EXPIRED,
          statusType: StatusType.QUOTE,
          colorTheme: 'expired',
          statusCount: this.tableData.expired,
        },
      ]
      if (this.tableData.quoteListingList.length > 0) {
        this.dataSource = [...this.tableData.quoteListingList]
        this.decreasing()
      } else {
        this.noData = true
      }
    })
  }

  keyUp(search, event) {
    if (event.keyCode === 13) {
      this.searchtext = search
      this.searchId = search.trim()
      this.searchcreatedby = false
      this.selectedCreated = null
      this.showSearch = false
      this.searchFilter = true
      this.noData = false
      this.crntPage = 0
      const obj = {
        createdDate: null,
        searchText: this.searchId,
        quoteReference: null,
        quoteStatusLabel: this.status,
        quoteTotal: null,
        endDate: this.toDate,
        startDate: this.fromDate,
        quoteRefreshFlag: false,
        PageSize: this.PageSize,
        currentPage: this.crntPage,
      }
      this.updatedTableData$ = this.quoteTrackingService.getQuote(obj)
      this.updatedTableData$.subscribe((res) => {
        this.noData = false
        this.tableData = res
        if (this.tableData.pagination !== undefined) {
          this.crntPage = this.tableData.pagination.currentPage
          this.totalPages = this.tableData.pagination.totalPages
          this.totalQuotes = this.tableData.pagination.totalResults
        } else {
          this.crntPage = 0
          this.totalPages = 0
          this.totalQuotes = 0
        }
        this.quoteTiles = [
          {
            quoteStatus: QuoteStatusTypes.TOTAL,
            statusType: StatusType.QUOTE,
            statusCount: this.tableData.allQuotes,
          },
          {
            quoteStatus: QuoteStatusTypes.SUBMITTED,
            statusType: StatusType.QUOTE,
            colorTheme: 'submitted',
            statusCount: this.tableData.created,
          },
          {
            quoteStatus: QuoteStatusTypes.PROGRESS,
            statusType: StatusType.QUOTE,
            colorTheme: 'progress',
            statusCount: this.tableData.inProgress,
          },
          {
            quoteStatus: QuoteStatusTypes.PENDING,
            statusType: StatusType.QUOTE,
            colorTheme: 'pending',
            statusCount: this.tableData.pendingAcceptance,
          },
          {
            quoteStatus: QuoteStatusTypes.RETURNED,
            statusType: StatusType.QUOTE,
            colorTheme: 'returned',
            statusCount: this.tableData.revisionRequested,
          },
          {
            quoteStatus: QuoteStatusTypes.CLOSED,
            statusType: StatusType.QUOTE,
            colorTheme: 'closed',
            statusCount: this.tableData.closed,
          },
          {
            quoteStatus: QuoteStatusTypes.EXPIRED,
            statusType: StatusType.QUOTE,
            colorTheme: 'expired',
            statusCount: this.tableData.expired,
          },
        ]
        if (this.tableData.quoteListingList.length > 0) {
          this.dataSource = [...this.tableData.quoteListingList]
          this.decreasing()
        } else {
          this.noData = true
        }
      })
    }
  }

  downloadXls() {
    const obj = {
      searchText: this.searchId,
      quoteStatusLabel: this.status,
      endDate: this.toDate,
      startDate: this.fromDate,
      quoteRefreshFlag: '',
    }
    this.quoteTrackingService.downloadQuoteListing(obj).subscribe((res) => {
      let fileName =
        'My_Quotes_' + this.datepipe.transform(this.toMinDate, 'dd-MM-yyyy')
      const blob = new Blob([res], { type: 'application/vnd.ms.excel' })
      const file = new File([blob], fileName + '.xlsx', {
        type: 'application/vnd.ms.excel',
      })
      saveAs(file)
    })
  }

  checkUserEnabled(flagName) {
    return this.userRoleService.checkUserRoleEnabled(flagName)
  }

  getselectedCreatedby(val) {
    this.selectedCreated = val
    this.searchFilter = false
    this.searchId = null
    this.showSearch = true
    this.searchFilter = false
    this.searchcreatedby = true
    this.clearAll = true
    // this.searchtext= search;
    this.searchId = val
    this.noData = false
    this.crntPage = 0
    const obj = {
      createdDate: null,
      searchText: val,
      quoteReference: null,
      quoteStatusLabel: this.status,
      quoteTotal: null,
      endDate: this.toDate,
      startDate: this.fromDate,
      quoteRefreshFlag: false,
      PageSize: this.PageSize,
      currentPage: this.crntPage,
    }
    this.updatedTableData$ = this.quoteTrackingService.getQuote(obj)
    this.updatedTableData$.subscribe((res) => {
      this.noData = false
      this.tableData = res

      if (this.tableData.pagination !== undefined) {
        this.crntPage = this.tableData.pagination.currentPage
        this.totalPages = this.tableData.pagination.totalPages
        this.totalQuotes = this.tableData.pagination.totalResults
      } else {
        this.crntPage = 0
        this.totalPages = 0
        this.totalQuotes = 0
      }
      this.quoteTiles = [
        {
          quoteStatus: QuoteStatusTypes.TOTAL,
          statusType: StatusType.QUOTE,
          statusCount: this.tableData.allQuotes,
        },
        {
          quoteStatus: QuoteStatusTypes.SUBMITTED,
          statusType: StatusType.QUOTE,
          colorTheme: 'submitted',
          statusCount: this.tableData.created,
        },
        {
          quoteStatus: QuoteStatusTypes.PROGRESS,
          statusType: StatusType.QUOTE,
          colorTheme: 'progress',
          statusCount: this.tableData.inProgress,
        },
        {
          quoteStatus: QuoteStatusTypes.PENDING,
          statusType: StatusType.QUOTE,
          colorTheme: 'pending',
          statusCount: this.tableData.pendingAcceptance,
        },
        {
          quoteStatus: QuoteStatusTypes.RETURNED,
          statusType: StatusType.QUOTE,
          colorTheme: 'returned',
          statusCount: this.tableData.revisionRequested,
        },
        {
          quoteStatus: QuoteStatusTypes.CLOSED,
          statusType: StatusType.QUOTE,
          colorTheme: 'closed',
          statusCount: this.tableData.closed,
        },
        {
          quoteStatus: QuoteStatusTypes.EXPIRED,
          statusType: StatusType.QUOTE,
          colorTheme: 'expired',
          statusCount: this.tableData.expired,
        },
      ]
      if (this.tableData.quoteListingList.length > 0) {
        this.dataSource = [...this.tableData.quoteListingList]
        this.decreasing()
      } else {
        this.noData = true
      }
    })
  }
  loadmoredatadropdown() {
    this.noData = false
    this.crntPage = 0
    const obj = {
      createdDate: null,
      searchText: this.searchId,
      quoteReference: null,
      quoteStatusLabel: this.status,
      quoteTotal: null,
      endDate: this.toDate,
      startDate: this.fromDate,
      quoteRefreshFlag: false,
      PageSize: this.PageSize,
      currentPage: this.crntPage,
    }
    this.updatedTableData$ = this.quoteTrackingService.getQuote(obj)
    this.updatedTableData$.subscribe((res) => {
      this.noData = false
      this.createdby = res

      if (this.tableData?.quoteListingList.length > 0) {
        this.dataSource = [...this.tableData.quoteListingList]
        this.decreasing()
      } else {
        this.noData = true
      }
    })
  }
  getNetPrice(netPrice) {
    if (netPrice.indexOf('JPY') != -1) {
      this.jpyCurrency = netPrice.split('.')
      return this.jpyCurrency[0]
    } else {
      return netPrice
    }
  }
}
